/**
 * Routes — Batch 1 has placeholder pages so the app renders something.
 * Batch 4 replaces these with the real dashboard page, clinic switcher,
 * and admin screens.
 */
import { createBrowserRouter, Navigate } from "react-router-dom";

import { ClinicListPage } from "@/components/ClinicListPage";
import { DashboardPage } from "@/components/DashboardPage";
import { AdminBenchmarksPage } from "@/components/admin/AdminBenchmarksPage";
import { AdminClinicsPage } from "@/components/admin/AdminClinicsPage";
import { AdminScoringRunsPage } from "@/components/admin/AdminScoringRunsPage";
import { AppShell } from "@/components/AppShell";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/clinics" replace /> },
      { path: "clinics", element: <ClinicListPage /> },
      { path: "clinics/:clinicId", element: <DashboardPage /> },
      { path: "clinics/:clinicId/year/:year", element: <DashboardPage /> },
      {
        path: "clinics/:clinicId/year/:year/meeting/:meetingId",
        element: <DashboardPage />,
      },
      { path: "admin", element: <Navigate to="/admin/clinics" replace /> },
      { path: "admin/benchmarks", element: <AdminBenchmarksPage /> },
      { path: "admin/clinics", element: <AdminClinicsPage /> },
      { path: "admin/scoring-runs", element: <AdminScoringRunsPage /> },
    ],
  },
]);
